import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/DashboardContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sidebar.tsx");
